var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    fill: "#444444",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2755 22.4418H7.85199V11.3814H11.2755V22.4418ZM9.54742 9.93301C8.42935 9.93301 7.52295 9.01923 7.52295 7.8922C7.52295 6.76504 8.42947 5.85132 9.54742 5.85132C10.6654 5.85132 11.5718 6.76504 11.5718 7.8922C11.5718 9.01929 10.6654 9.93301 9.54742 9.93301ZM24.105 22.4418H20.6981V16.636C20.6981 15.0437 20.0933 14.1548 18.8341 14.1548C17.4638 14.1548 16.7479 15.0806 16.7479 16.636V22.4418H13.4644V11.3814H16.7479V12.8711C16.7479 12.8711 17.7356 11.0441 20.0809 11.0441C22.4262 11.0441 24.1051 12.4761 24.1051 15.4385L24.105 22.4418Z",
    fill: "#F2F2F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin2);
export default __webpack_public_path__ + "static/media/linkedin2.823278f8d6f015442c5c102b4ca8b6ee.svg";
export { ForwardRef as ReactComponent };